import instance from '../scorpiusInstance';
import {
  FETCH_APP_CIDRS_START,
  FETCH_APP_CIDRS_SUCCESS,
  FETCH_APP_CIDRS_ERROR,
} from '../types';

export const fetchAppCIDRsStart = (orgId, appName) => ({
  type: FETCH_APP_CIDRS_START,
  orgId,
  appName,
});

export const fetchAppCIDRsSuccess = (orgId, appName, CIDRs) => ({
  type: FETCH_APP_CIDRS_SUCCESS,
  orgId,
  appName,
  CIDRs,
});

export const fetchAppCIDRsError = (orgId, appName, error) => ({
  type: FETCH_APP_CIDRS_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Fetch all CIDR records for an organization application.
 * @param {String} orgId - The organization's ID
 * @param {String} appName
 */
export const fetchAppCIDRs = (orgId, appName) => async dispatch => {
  dispatch(fetchAppCIDRsStart(orgId, appName));
  try {
    const response = await instance.get(`/organizations/${orgId}/cidrs`, {
      headers: { retry: true },
    });
    return dispatch(fetchAppCIDRsSuccess(orgId, appName, response.data));
  } catch (error) {
    throw dispatch(fetchAppCIDRsError(orgId, appName, error));
  }
};

export default fetchAppCIDRs;
